import {omneticApi} from '@dms/api/base';

import {EditTopMakesApiArg, EditTopMakesApiResponse, GetTopMakesApiResponse} from './types';

export const topMakesApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    editTopMakes: build.mutation<EditTopMakesApiResponse, EditTopMakesApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/top-makes`,
        method: 'PUT',
        body: queryArg.editTopMakesRequestBody,
      }),
      invalidatesTags: ['TopMakes'],
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        const optimisticValue = arg.editTopMakesRequestBody.makes.map((code) => ({code}));

        const patchResult = dispatch(
          topMakesApi.util.updateQueryData('getTopMakes', undefined, () => optimisticValue)
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    getTopMakes: build.query<GetTopMakesApiResponse, void>({
      query: () => ({
        url: `/dms/v1/vehicle/top-makes`,
      }),
      providesTags: ['TopMakes'],
    }),
  }),
});

export const {useEditTopMakesMutation, useGetTopMakesQuery, useLazyGetTopMakesQuery} = topMakesApi;
